import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, Box, useMediaQuery, useTheme } from "@mui/material";
export const SkippedMealOverlay = ({ children }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    return (_jsx(Box, Object.assign({ id: "skipped-meal-overlay", "aria-hidden": true, display: "flex", justifyContent: "center", alignItems: "center", sx: (theme) => ({
            position: "absolute",
            bottom: 0,
            left: 0,
            height: "100%",
            zIndex: 500,
            width: "100%",
            pointerEvents: "auto",
            background: alpha(theme.palette.common.white, 0.65),
        }) }, { children: _jsx(Box, Object.assign({ id: "skipped-meal-content", display: "flex", justifyContent: "center", alignItems: "center", sx: { m: 5, position: isMobile ? "absolute" : "relative", top: isMobile ? "15%" : "auto" } }, { children: children })) })));
};
